// extracted by mini-css-extract-plugin
module.exports = {"reportContainer":"index-module_reportContainer_1LjGN"};